<div class="modal-header border-0 pb-0">
  <h5 class="modal-title fw-bold">Bulk Upload Suburbs</h5>
  <button type="button" class="btn-close shadow-none" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body pt-3">
  <div class="alert alert-info border-0 shadow-sm rounded-4 d-flex align-items-start gap-3 mb-4">
    <i class="bi bi-info-circle-fill fs-4 text-info mt-1"></i>
    <div class="small flex-grow-1">
      <p class="mb-2 fw-bold">Download Template First</p>
      <p class="mb-3 text-muted">Use our standard template to ensure your suburbs are mapped correctly.</p>
      <button type="button" class="btn btn-primary btn-sm shadow-sm fw-bold px-3 py-2" (click)="downloadTemplate()" [disabled]="isDownloadingTemplate">
        <span *ngIf="isDownloadingTemplate" class="spinner-border spinner-border-sm me-2"></span>
        <i *ngIf="!isDownloadingTemplate" class="bi bi-download me-2"></i>
        Download Template
      </button>
    </div>
  </div>

  <div class="drag-area" [class.dragover]="isDragOver" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onFileDrop($event)">
    <div class="text-center">
      <div *ngIf="!selectedFile">
        <i class="bi bi-file-earmark-arrow-up fs-1 text-primary mb-2 d-block"></i>
        <p class="fw-bold mb-1">Click to browse or drag and drop</p>
        <p class="text-muted small mb-0">CSV files supported</p>
      </div>

      <div *ngIf="selectedFile" class="animate-fade-in">
        <i class="bi bi-file-check-fill fs-1 text-success mb-2 d-block"></i>
        <p class="fw-bold mb-1 text-truncate px-3">{{ selectedFile.name }}</p>
        <p class="text-success extra-small fw-bold mb-0">FILE ATTACHED</p>
      </div>
    </div>
    <input type="file" class="file-input" (change)="onFileSelect($event)" accept=".csv">
  </div>

  <div *ngIf="selectedFile" class="mt-3 text-center">
    <button type="button" class="btn btn-link btn-sm text-danger text-decoration-none fw-bold" (click)="removeFile()">
      <i class="bi bi-trash me-1"></i> Remove File
    </button>
  </div>
</div>

<div class="modal-footer border-0">
  <button type="button" class="btn btn-light px-4 rounded-3 fw-bold" (click)="activeModal.dismiss()">Cancel</button>
  <button type="button" class="btn btn-primary px-4 rounded-3 fw-bold shadow-sm" [disabled]="!selectedFile || isLoading" (click)="uploadFile()">
    <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2"></span>
    <i *ngIf="!isLoading" class="bi bi-cloud-arrow-up me-2"></i>
    Confirm Upload
  </button>
</div>
